// extracted by mini-css-extract-plugin
export var label = "_ki-2";
export var slideContainer = "_ki-0";
export var slider = "_ki-1";